import React from 'react'

function About() {
    return (
        <div>
            UI/UX Designer & Developer
Dolor reprehenderit aut repudiandae maiores recusandae. Consequatur dolor nisi labore commodi ipsa? Excepturi velit laboriosam at voluptatibus cupiditate est vel. Dolorem praesentium itaque fugiat placeat quas consequatur? Obcaecati natus rerum

Consectetur consectetur nesciunt nesciunt blanditiis amet? Quod quis unde aliquid excepturi laudantium? Illo architecto aliquam velit illo magnam neque perferendis sint Incidunt eius ipsa inventore labore eos velit. Minus hic magni reiciendis necessitatibus ex Quidem officia deleniti accusamus obcaecati dolores. Porro culpa quibusdam impedit porro praesentium excepturi. Alias ab consequatur?

Personal Information
NamePhilip Watson
Age26 Years
ResidenceNew York, USA
Address123 Lorem Ipsum
Emailexample@example.com
Phone(+1) 123 456 7890
FreelanceAvailable
        </div>
    )
}

export default About
